// 全屏-门禁
<template>
  <div class="DkbFAccess">
    门禁内容
  </div>
</template>

<script>
  import { localUserInfo, showToast } from "../../../../static/js/utility/utility.js"
  let vm

  export default {
    name: 'DkbFAccess',
    components: {
    },
    data () {
      return {
      }
    },
    created () {
      vm = this
   
    },
    mounted() {
      // console.log('route', this.$route)
    },
    computed: {
    },
    methods: {
    },
    watch: {
    }
  }
</script>

<style lang="scss" scoped>
.DkbFAccess {

}
</style>



// WEBPACK FOOTER //
// src/components/DkbPage/FScreen/Access.vue